import { IDashboardProps } from "@/types/dashboard.types";
import { get } from "../../utils/BaseService";

export async function getDashboardSummary(dispatch: any, props:IDashboardProps) {
  return await get(dispatch, '/dashboard/summary', props);
}